import {createContext, ReactNode, useEffect, useState} from "react";
import {useLocation} from "react-router";

import {useMediaQuery} from "@/lib/hooks/useMediaQuery.ts";

interface NavBarContext {
  isMenuOpen: boolean;
  setIsMenuOpen: (isMenuOpen: boolean) => void;

  isProfileMenuOpen: boolean;
  setIsProfileMenuOpen: (isMenuOpen: boolean) => void;

  isMobile: boolean;
}

const DefaultValues: NavBarContext = {
  isMenuOpen: false,
  setIsMenuOpen: () => {},

  isProfileMenuOpen: false,
  setIsProfileMenuOpen: () => {},

  isMobile: false,
};

export const NavBarContext = createContext<NavBarContext>(DefaultValues);

export const useNavBar = (): NavBarContext => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 1024px)");

  useEffect(() => {
    setIsMenuOpen(false);
    setIsProfileMenuOpen(false);
  }, [isMobile]);

  return {
    isMenuOpen,
    setIsMenuOpen,
    isProfileMenuOpen,
    setIsProfileMenuOpen,
    isMobile,
  };
};

export const useIsSpecialCasePage = (specialCasePages?: string[]): boolean => {
  const {pathname} = useLocation();
  return specialCasePages?.some((pattern) => new RegExp(pattern).test(pathname)) ?? false;
};

interface NavBarContextProviderProps extends NavBarContext {
  children: ReactNode;
}

export const NavBarContextProvider = ({children, ...rest}: NavBarContextProviderProps) => {
  return <NavBarContext.Provider value={{...rest}}>{children}</NavBarContext.Provider>;
};
